// extracted by mini-css-extract-plugin
module.exports = {"options":"Options_options__3zLwO","button":"Options_button__1FVeh","favorite":"Options_favorite__12n_T"};